/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-09-09                                                        *
 ******************************************************************************/

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import DeviseAuthStore from '../../vuex/stores/devise-auth';
import LoadingSpinnerStore from "../../vuex/stores/loading-spinner";
import ConfigurationTemplatesStore from "../../vuex/stores/configuration-templates";
import CurrentUserStore from "../../vuex/stores/current-user";
import QuoteVersionsStore from "../../vuex/stores/quote-versions";
import QuotePartsStore from "../../vuex/stores/quote-parts";
import QuoteProductDetailsStore from "../../vuex/stores/quote-product-details";
import MacroResultsStore from "../../vuex/stores/macro-results";
import QuotePublishingStore from "../../vuex/stores/quote-publishing";
import PublicQuoteProductsStore from "../../vuex/stores/public-quote-products";
import QuoteProductsStore from "../../vuex/stores/quote-products";
import ConfigurationCategoriesStore from "@/vuex/stores/configuration-categories";
import ConfigurationCategoryAssignmentsStore from "@/vuex/stores/configuration-category-assignments";

const store = new Vuex.Store({
    modules: {
        DeviseAuthStore,
        LoadingSpinnerStore,
        CurrentUserStore,
        ConfigurationTemplatesStore,
        QuoteProductsStore,
        PublicQuoteProductsStore,
        QuoteVersionsStore,
        QuotePartsStore,
        QuoteProductDetailsStore,
        MacroResultsStore,
        QuotePublishingStore,
        ConfigurationCategoriesStore,
        ConfigurationCategoryAssignmentsStore,
    }
});

export default store;
